import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 240 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#49021F",
      d: "M196.959 0H43.041C19.271 0 0 19.27 0 43.041V196.96C0 220.73 19.27 240 43.041 240H196.96C220.73 240 240 220.73 240 196.959V43.041C240 19.271 220.73 0 196.959 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#F36",
      d: "M57.863 63.706h30.713v110.633H57.863zM99.08 131.737c0-30.053 22.456-45.079 45.738-45.079 3.138 0 6.441.33 8.422.66v-27.08h28.897v108.486c-6.936 3.468-20.641 7.101-35.502 7.101-25.429 0-47.556-14.366-47.556-44.088m54.16 19.98v-40.455c-1.981-.661-4.458-1.156-7.76-1.156-9.083 0-17.504 5.284-17.504 21.135 0 14.531 7.596 21.136 17.668 21.136 2.312 0 5.45-.165 7.596-.66"
    }, null, -1)
  ])))
}
export default { render: render }